import { environment } from 'src/environments/environment';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import { AutenticaoService } from 'src/app/auth/autenticacao.service';
import { Protocolo } from 'src/app/models/protocolo/protocolo.model';
import { ProtocoloPedido } from 'src/app/models/protocolo/protocolo.pedido.model';
import { FotografiaService } from '../fotografia/fotografia.service';
import { ProtocoloService } from './protocolo.service';
import { MockTest } from 'src/app/utils/mock-test';

@Component({
  selector: 'app-protocolo',
  templateUrl: './protocolo.component.html',
  styleUrls: ['./protocolo.component.scss']
})
export class ProtocoloComponent implements OnInit {
  protocolo: Protocolo;
  protocoloPedido: ProtocoloPedido;
  constructor(private fotografiaService: FotografiaService, private protocoloService: ProtocoloService, private router: Router, private autenticaoService: AutenticaoService) {
    this.protocolo = new Protocolo();
    this.protocoloPedido = new ProtocoloPedido();
  }

  ngOnInit(): void {
    this.obterProtocolo();
  }

  obterProtocolo() {
    const decoded = jwt_decode(sessionStorage.getItem('accessTokenJWT'));
    if (environment.name == 'local') {
      this.protocoloPedido.documentoCliente = sessionStorage.getItem("document");
      this.protocoloPedido.email = sessionStorage.getItem("email");
      const protocolo = MockTest.criarMockProtocolo();

      this.fotografiaService.fotografia.documentoCliente = protocolo.documentoCliente;
      this.fotografiaService.fotografia.dataGeracaoProtocolo = protocolo.dataGeracao.toString();
      this.fotografiaService.fotografia.numeroProtocolo = protocolo.numeroProtocolo.toString();
      this.fotografiaService.fotografia.origemRelatorio = "SERASA_CONSUMIDOR";
      this.fotografiaService.fotografia.emailCliente = protocolo.email;
      this.fotografiaService.fotografia.origem = 22;
      if (decoded.authorities.toString().includes("ROLE_PERSON_VALIDATED")) {
        this.fotografiaService.fotografia.meio = 36;
      } else {
        this.fotografiaService.fotografia.meio = 33;
      }
      return
    }

    this.protocoloPedido.documentoCliente = sessionStorage.getItem("document");
    this.protocoloPedido.email = sessionStorage.getItem("email");
    this.protocoloService.obterProtocolo(this.protocoloPedido).subscribe(res => {
      this.protocolo = res;
      //Geracao Dados para Fotografia
      this.fotografiaService.fotografia.documentoCliente = this.protocolo.documentoCliente;
      this.fotografiaService.fotografia.dataGeracaoProtocolo = this.protocolo.dataGeracao.toString();
      this.fotografiaService.fotografia.numeroProtocolo = this.protocolo.numeroProtocolo.toString();
      this.fotografiaService.fotografia.origemRelatorio = "SERASA_CONSUMIDOR";
      this.fotografiaService.fotografia.emailCliente = this.protocolo.email;
      this.fotografiaService.fotografia.origem = 22;
      if (decoded.authorities.toString().includes("ROLE_PERSON_VALIDATED")) {
        this.fotografiaService.fotografia.meio = 36;
      } else {
        this.fotografiaService.fotografia.meio = 33;
      }

    }, err => {
      console.log("Erro geracao Protocolo!", err);
      sessionStorage.setItem("idErro", '2001');
      this.router.navigate(["/erro"]);
    });
  }

}
